export const downloadQCBDFile = (url: string, filename: string) => {
	const encodedUrlFromBackend = encodeURIComponent(url);
	const encodedFilename = encodeURIComponent(filename);
	const downloadUrl = `${window.location.origin}/files/GetAndRename?url=${encodedUrlFromBackend}&newFilename=${encodedFilename}`;

	const link = document.createElement("a");
	link.href = downloadUrl;
	link.download = filename;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};
